export default `'Century Gothic', 'Dank Mono', 'Kosugi Maru', 'Noto Sans', sans-serif`;
